
// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import addressValidationFactory from '../common/AddressValidation.js';
import { setElementsFromScope } from '../../utilities/selectorHelpers';
require("./selfOnboarding.less");
// Additional Imports...

let done;
var enableUserEnteredAddressRadioForSPL =true;
var disableSubmitAddressBtnIfInvalidAddressForSPL = true;

const modalHtml = require("../../sharedHtml/modal.html");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { createPreventDefault } from '../../utilities/general';
import { create } from 'underscore';

const elementsMap = {
  configDoneBtn: ".submit-facility-setup-wizard",
  smartPostBtn: ".smart-post-btn",   
  defaultProductBtn: ".default-prodct-btn",
  emailShippingAddressBtn: ".email-shipping-address-btn",
  addReasonBtn: ".add-reason-btn",
  editAccountAddressSection: ".edit-account-address-section",
  copyTextLink: ".copy-text"
}

const elsModalMap = {
  editAddressBtn: ".edit-address-btn",
}

const targetSelector = "#fedex-accounts-configuration-sandbox";

// Modal Html to use

run(targetSelector, (el)=>{
  attachStubExample(el);
});

export default function attachStubExample(el) {
  let facilitySetupWizard, addressErrorModal;
  let submitModal;

  const els = {};
  const elsModal = {};

  // START: REQUIRED TO LOAD STUB
  const entryEl = $("<div class='entry-point'></div>");
  const mainHtml = render(
    require("./html/selfOnboarding.html"), {
    accounts: require("./html/accounts.html"),
    locations: require("./html/sandbox-locations.html"),
    products: require("./html/products.html"),
    returnConfigurations: require("./html/returnConfigurations.html"),
    summary: require("./html/summary.html"),
  });

  const mainEl = $(mainHtml);
  //$(targetSelector).html(entryEl);
  $(el).html(entryEl);
  entryEl.append(mainEl);
  const saveFedexAccountUrl = el.data("save-fedex-account-url");
  const saveAccountAddressUrl = el.data("save-account-address-url");
  const addressValidationUrl = el.data("address-validation-url");
  const saveFacilityDetailsUrl = el.data("save-facility-details-url");
  const facNameCheckUrl = el.data("fac-name-check-url")
  const facIdCheckUrl = el.data("fac-id-check-url");
  const retailerName = el.data("retailer-name");
  const retailerWebUrl = el.data("retailer-web-url");
  const retailerAddress1 = el.data("retailer-address1");
  const retailerAddress2 = el.data("retailer-address2");
  const retailerCity = el.data("retailer-city");
  const retailerState = el.data("retailer-state");  
  const retailerZipCode = el.data("retailer-zip-code");
  const countryCode = el.data("retailer-country-code");
  const usaStates = el.data('usa-states'); 
  const caProvinces = el.data('ca-provinces'); 
  const addressStateSelect = $("#address-state");
  const addressValidationFor = el.data('address-validation-for');
  const addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
  const addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
  const validationReqdCountries = el.data('validation-reqd-countries');
  const defaultCountry = el.data('default-country');
  const CountryList = el.data('countries');
  const namespace = el.data('namespace');
  const sandboxflag = true;
  //const saveFedexAccountUrl = el.data("save-sandbox-fedex-account-url");

   //Sandbox config sterp1 smart psot flag
   const smartPostSwitchery = $('#international-shipping-sps');
   let sandboxSmartPostFlag = true;  
   let sandboxAccountNumber;  

  //Sandbox Default item switch & Return reasons list
  const defaultProductsSwitchery = $('#international-shipping');
  let useDefaultItemFlagforSB = false;
  const defaultProductsUrl = el.data("default-products-url");

  const fedexBrandEmailSwitchery = $('#fedEx-branded-email');
  let sandBoxEmailFlag = false;
  const emailShippingAddressUrl = el.data("email-shipping-address-url");

  const overrideShippingSwitchery = $('#show-ability-override');
  let SandboxOverrideShippingFlag = false;

  const overrideAddressSwitchery = $('#show-ability-override-address');
  let sandboxShippingAddressFlag = false;

  const returnReasonsUrl = el.data("return-reasons-url");  
  let responseData;

  const sobConfigDoneEmailUrl = el.data("sob-config-done-url");
  let configComplete = true;
  // END: REQUIRED TO LOAD STUB
  
  // START: REAL CODE

  function init() {
    initQuickWizard();
    generateModals();
    setElementsInModals();
    setElements();
    bindElements();

    els.editAccountAddressSection.hide();
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, mainEl);
  }

  function setElementsInModals() {
    const body = $('body');
    setElementsFromScope(elsModal, elsModalMap, body);
  }

  function bindElements() {
    //els.submitBtn.click(createPreventDefault(showSubmitModal));
    //els.createBtn.click(createPreventDefault(showAccountInfoModal));
    els.copyTextLink.click(createPreventDefault(copyToClipboard));
    els.smartPostBtn.on("click", createFedexAccount);
    //sandbox defult item swithch save
    els.defaultProductBtn.click(function (e) {
      e.preventDefault();
      console.log('default switch -->>');  
      saveDefaultProducts({ urlDf: defaultProductsUrl });
    });
    // send email once config is done 
    els.configDoneBtn.click(function (e) {
      e.preventDefault();
      console.log('Sand box config done -->>');  
      sendConfigDoneEmail({ configDoneurl: sobConfigDoneEmailUrl });
    });
    // branded email, default shipping override and address 
    els.emailShippingAddressBtn.click(function (e) {
    e.preventDefault();
    console.log('default switch -->>');  
    saveEmailShippingAddress({ urlEsa: emailShippingAddressUrl });
    });
    //Sandbox Return reason list button function
    els.addReasonBtn.click(function (e) {
      e.preventDefault();  
      addReason({ url: returnReasonsUrl });
    });
    //for modal edit button
    elsModal.editAddressBtn.click(createPreventDefault(showAddressErrorModal));
  }

   // production: prevent previous button navigation
   function initQuickWizard() {
    facilitySetupWizard = new QuickWizard(mainEl, {     
      tabletWidthNavStep: 1090,
      mobileWidthNavStep: 950,
      shouldNavigateToForm: ({ targetForm, direction, currentForm, done }) => {
          // Any time we go traverse backwards, just let us
          if(currentForm.filter(".so-products-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||(targetForm.filter(".so-locations-tab").length)){
              direction = "BACKWARDS";
            }
          }

          if(currentForm.filter(".so-returnConfigurations-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||(targetForm.filter(".so-locations-tab").length)||(targetForm.filter(".so-products-tab").length)){
              direction = "BACKWARDS";
            }
          }

          if(currentForm.filter(".so-summary-tab").length){
            if((targetForm.filter(".so-accounts-tab").length)||
            (targetForm.filter(".so-locations-tab").length)||(targetForm.filter(".so-products-tab").length)||(targetForm.filter(".so-returnConfigurations-tab").length)){
              direction = "BACKWARDS";
            }
          }

      if (direction === "BACKWARDS") {    
        return false;
      }
      console.log("inside backwards -->>3");
        return true;
      },
      
      didNavigateToForm: ({ currentForm }) => {      
        return true;       
      }
    });
    
    facilitySetupWizard.init();
    
    $(document).on('click', "[data-target-form]", function () {      
      const form = mainEl.find($(this).data("target-form"));      
      facilitySetupWizard.gotToForm(form);
    });
  
  }
//sandbox-account-id sandbox-hub-id
  function createFedexAccount(){    
    $.ajax({
      data:{
        "fedExShippingAccountNumber": $(".fedex-shipping-account-num").val(),
        "smartPostHubId": $(".smart-post-hub-id").val(), 
        "sandboxflag"   : sandboxflag,   
      },
      url: saveFedexAccountUrl,
      dataType:"JSON",
      type: 'POST',
      success: function (data) {
        console.log('in success' +data.data);
        sandboxAccountNumber = data.data;
         if(null !== data.data){
         $(".fac-ship-acc-number").val(data.data); 
        }  
      }
  }); 

  } 

  function generateModals() {
    submitModal = new SubmitModalFlow({ 
      confirmModalTitle: 'Save Facility',
      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
      confirmModalBtnText: 'Save',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        // Show Loading Modal
        submitModal.showLoadingModal();

        // Success
        setTimeout(function () {
          submitModal.showSuccessModal();
        }, 3000);

        // Hide All Modals
        setTimeout(function () {
          submitModal.hideAllModals();
        }, 6000);
      }
    });

    submitModal.init();

    addressErrorModal = $(render(
      modalHtml, {
      title: 'Registration Error Details',
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-activate-rule modal-auto-hide">Cancel</a>\
          <a href="#" class="base-btn purple-btn edit-address-btn">Edit Address</a>',
      body: "<div class='q-marg-all-xl'>There appears to be an issue with FedEx Meter services while registering the given Fedex Account Number. <div><br/>Validate the Account Number, Registered Address match, and if they do not match click the edit address button to correct the issue.</div></div>",
      topCloseBtn: true,
      autoHideTop: true,
      leftAlignTitle: true,
      modalDialogClass: "q-modal-dialog-500"
    }
    ));

    mainEl.append([addressErrorModal]);

  };

  function showSubmitModal() { 
    submitModal.showConfirmModal();
  }

  console.log('before email ajax' );   
  function sendConfigDoneEmail({ configDoneurl }) {
    {
      $.ajax({
        data: {
          "configComplete": configComplete   
        },
        url: configDoneurl,
        dataType: 'JSON',
        type: 'POST',
        success: function (data) {
          console.log('config done '+ data.status );    
          console.log('config done email ajax ' + JSON.stringify(data)); 
          
          console.log('in show submit');    
          let myUrl =   "/c/portal/logout";
          window.open(myUrl, '_self', '');
          console.log('in show submit-- '+myUrl); 
        }
      });
    }
  } 

  function showAccountInfoModal() {
    addressErrorModal.modal("show");
  }

  function showAddressErrorModal() {
    addressErrorModal.modal("hide");
    els.editAccountAddressSection.show();
  }
  
/* //Sandbox Config step 1 smart post switch 
smartPostSwitchery.on('change', function (e) {
  if (smartPostSwitchery.is(":checked")) {
    sandboxSmartPostFlag = true;
    console.log('sandboxSmartPostFlag in sbv-->' + sandboxSmartPostFlag);
  } else {
    sandboxSmartPostFlag = true;
    console.log('sandboxSmartPostFlag in sb--> ' + sandboxSmartPostFlag);
  }
}); */

$(CountryList).each(function(){
  var option = $('<option />');
  option.attr('value', this.conCode).text(this.conName);
  //option.attr('value', this.cdmValue).text(this.cdmMeaning);
  $('#selfLocationCountry').append(option);
});

$('#selfLocationCountry').change(function(){
  var countryVal = $('#selfLocationCountry option:selected').val();
  setStates(countryVal);
});

function setStates(countryVal) {
  $('#selfLocationState').html('');
  var option = $('<option />');
  option.attr('value', "-1").text('Select State/Province/Region');
  option.attr('selected','selected');
  option.attr('disabled','disabled');
  let checkZipCode = false;
    $(CountryList).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });
  if(countryVal == "US" && checkZipCode) {
    $('#selfLocationStateContainer').css("display", "block");
    $('#facstateTextContainer').css("display", "none");
    $('#facstateText').prop('required',false);
    $('#selfLocationState').prop('required',true);
    $('#selfLocationState').append(option);
    $(usaStates).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
    
      $('#selfLocationState').append(option);
    });
  } else if(countryVal == "CA" && checkZipCode) {
    $('#selfLocationStateContainer').css("display", "block");
    $('#facstateTextContainer').css("display", "none");
    $('#facstateText').prop('required',false);
    $('#selfLocationState').prop('required',true);
    $('#selfLocationState').append(option);
    $(caProvinces).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      $('#selfLocationState').append(option);
    });
  } else{
    $('#facstateText').prop('required',false);
    $('#selfLocationState').prop('required',false);
   $('#selfLocationStateContainer').css("display", "none");
   $('#facstateTextContainer').css("display", "block");
  }
}

$(".fac-loc-id").change(function(){
 console.log("inside duplicate fac id check ");
  validateFacilityId();
});
$(".fac-loc-name").change(function(){
validateFacilityName();
});

$('.add-location-btn').click(function(event){
  event.preventDefault();
  console.log("Inside acoount add button func");

  var requiredFields  = $('#saveLocationSection input, select').filter('[required]:visible');
  var allRequired =true;
  requiredFields.each(function(){
  $("#requriedFieldError").each(function(){
    $(this).remove();
});
});
  requiredFields.each(function(){
      if($(this).val() == ''){
        allRequired=false;
        var error = '<label id="requriedFieldError" class="help-block" style="color: red;">The field is required !!</label>';
        $(this).after(error);
      }
  });
  console.log("allRequired is :" +allRequired);
  if(allRequired){
  const addressValidationModalEl = $("#add-validation-model");
  const addressValidationForSelfFacilityTabSbox = addressValidationFactory(null, el, {
    isAlreadyValid: false,
    currentTab: ".so-locations-tab",
    disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
    disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
  });
  console.log("address value " +JSON.stringify(addressValidationForSelfFacilityTabSbox.determineAddressValidity(done))); 
  console.log("Address Validation :  "+document.getElementById("addLocationFlagForAddressValidation").value +"     "+$("#addLocationFlagForAddressValidation").val());
  if(document.getElementById("addLocationFlagForAddressValidation").value == 'Validated')
  {
    //saveFacilityDetails();
  }

  /*$("#shipToLocations").css("display","block");
  $("#shipToLocationsEdit").css("display","block");*/
  viewFacilityDetails();

  $('.qw-nav-step').each(function(){
    
    var tabValue =  $(this).attr('data-qw-form-target');
    console.log('this is inside tabs list '+tabValue);
    if(tabValue === '.so-accounts-tab'){
      console.log('accounts tab hide');
          $(this).removeClass('active');
          $(this).addClass('visited');
    }
    if(tabValue === '.so-locations-tab'){
      console.log('Sand box location tab show');
      $(".loc-next-btn").removeClass('disabled');
      $(this).addClass('active');
      
}
  });
}
});

$('.loc-next-btn').click(function(event) {
  console.log("Inside Next Button loc screen")
  saveFacilityDetails();
});
$("#self-save-loc-cancel").click(function(){
  $("#saveSelfLocation").modal("hide");
});
$("#self-save-loc-continue").click(function(){
  saveFacilityDetails();
  $("#saveSelfLocation").modal("hide");
});
  function saveFacilityDetails(){
    $('.fac-id-view').text($(".fac-loc-id").val());
    if($(".fac-country").val() == 'US' || $(".fac-country").val() == 'CA'){
       let facState = $(".fac-state").val();
    }else{
       let facState = $(".fac-state-text").val();
    }
    $.ajax({
      data: {
      "facilityid" :  $(".fac-loc-id").val(),
      "facilityname" : $(".fac-loc-name").val(),
      "facAddress1" : $(".fac-address1").val(),
      "facAddress2" : $(".fac-address2").val(),
      "facCity" : $(".fac-city").val(),
      "facState" : $(".fac-state").val(),
      "facZipcode" : $(".fac-zip-code").val(),
      "facCountry" : $(".fac-country").val(),
      "facContactname" : $(".fac-contactname").val(),
      "facEmail" : $(".fac-contact-email").val(),
      "facPhone" : $(".loc-contact-phone").val(),
         },
      url: saveFacilityDetailsUrl,
      dataType:"JSON",
      type: 'POST',

      success: function(response) {
        //var activeTab = $(".tabs").tabs( "option", "active" );
        submitModal.showSuccessModal();
        setTimeout(function () { submitModal.hideAllModals(); }, 100);
        $(".loc-next-btn").removeClass('disabled'); 
      // $("#shipToLocations").css("display","block");
       //$("#shipToLocationsEdit").css("display","block");
       $("#saveLocationSection").children().prop("disabled", true);
      // $("#saveLocationSection").css("dsiplay", "none");
      // $('.add-location-btn').attr('disabled','disabled');
       //$("#saveLocationSection").hide();
       //$(".loc-next-btn").removeAttr('disabled');
       document.getElementById("locNextBtn").disabled = false;
        console.log("insid sucess add fac function");
       //viewFacilityDetails();
      },     
      error: function(){
        $(".loc-next-btn").removeClass('enabled');
        submitModal.showFailureModal();
      }
    });
}

$('.loc-edit').click(function(event) {
  showFacility();
  console.log("Inside edit butto loca screen");
  event.preventDefault();
  //$("#saveLocationSection").css("dsiplay", "block");
  //$("#saveLocationSection").show();
  $('.add-location-btn').removeAttr('disabled');

  $('.fac-loc-id').prop("disabled", false);
  $('.fac-loc-name').prop("disabled", false);
  $('.fac-address1').prop("disabled", false);
  $('.fac-address2').prop("disabled", false);
  $('.fac-city').prop("disabled", false);
  $('.fac-state').prop("disabled", false);
  $('.fac-zip-code').prop("disabled", false);
  $('.fac-country').prop("disabled", false);
  $('.fac-contactname').prop("disabled", false);
  $('.fac-contact-email').prop("disabled", false);
  $('.loc-contact-phone').prop("disabled", false);
  $('.fac-ship-acc-number').prop("disabled", false);
});

function viewFacilityDetails()
{
  console.log("inside view facilyty details test ");
 // hideFacilty();
//$("#saveLocationSection").css("dsiplay", "none");
$('.add-location-btn').attr('disabled','disabled');

$('.fac-loc-id').prop("disabled", true);
$('.fac-loc-name').prop("disabled", true);
$('.fac-address1').prop("disabled", true);
$('.fac-address2').prop("disabled", true);
$('.fac-city').prop("disabled", true);
$('.fac-state').prop("disabled", true);
$('.fac-zip-code').prop("disabled", true);
$('.fac-country').prop("disabled", true);
$('.fac-contactname').prop("disabled", true);
$('.fac-contact-email').prop("disabled", true);
$('.loc-contact-phone').prop("disabled", true);
$('.fac-ship-acc-number').prop("disabled", true);

$('.fac-id-view').text($(".fac-loc-id").val());
$('.fac-name-view').text($(".fac-loc-name").val());
$('.fac-address1-view').text($(".fac-address1").val());
$('.fac-address2-view').text($(".fac-address2").val());
$('.fac-city-view').text($(".fac-city").val());
$('.fac-state-view').text($(".fac-state").val());
$('.fac-zipcode-view').text($(".fac-zip-code").val());
$('.fac-country-view').text($(".fac-country").val());
$('.fac-contactname-view').text($(".fac-contactname").val());
$('.fac-contact-email-view').text($(".fac-contact-email").val());
$('.fac-phone-view').text($(".loc-contact-phone").val());
$('.fac-shipping-account-view').text($(".fac-ship-acc-number").val());
}


//sandbox collapse after save locations
function showFacility() {
  debugger;
  console.log("in collapse");
  var x = document.getElementById("saveLocationSection"); 
    x.style.display = "block";      
}

function hideFacilty() {
  debugger;
  console.log("in collapse");
  var x = document.getElementById("saveLocationSection");
    x.style.display = "none";   
  
}

//duplicate facility name check
function validateFacilityName() {
const facName = $(".fac-loc-name").val();
$.ajax({
    async: false,
    data: {
      facName:facName
    },
    url: facNameCheckUrl,
    dataType:"JSON",
    type: 'POST',
    success: function(data){
      if(data.response== true) {
        $(".dup-facName").show();  
      }else{
        $(".dup-facName").hide();
      }  
    }  
 });
}

function validateFacilityId() {
console.log("inside check fac id ajax call");
console.log("facIdCheckUrl is :" +facIdCheckUrl);
const facId =   $(".fac-loc-id").val();
$.ajax({
    async: false,
    data: {
      facId:facId
    },
    url: facIdCheckUrl,
    dataType:"JSON",
    type: 'POST',
    success: function(data){
      console.log("inside sucess go fac id " +data.response);
      if(data.response== true) {
        $(".dup-facId").show();
      }else{
        $(".dup-facId").hide();
      }  
    }  
 });

}
//Sandbox Config step 3 default product 
defaultProductsSwitchery.on('change', function (e) {
  if (defaultProductsSwitchery.is(":checked")) {
    useDefaultItemFlagforSB = true;
    console.log('useDefaultItemFlagforSB in sbv-->' + useDefaultItemFlagforSB);
  } else {
    useDefaultItemFlagforSB = false;
    console.log('useDefaultItemFlagforSB in sb--> ' + useDefaultItemFlagforSB);
  }
});

//Production Config step 3  save default product
function saveDefaultProducts({ urlDf }) {
  {
    $.ajax({
      data: {
        "defaultProduct": useDefaultItemFlagforSB   
      },
      url: urlDf,
      dataType: 'JSON',
      type: 'POST',
      success: function (data) {
        console.log('res1 '+ data.status );    
        console.log('prod in defautl products ajax ' + JSON.stringify(data));  
      }
    });
  }
}

//Sandbox Config step 4 Fedex Branded email swich 
fedexBrandEmailSwitchery.on('change', function (e) {
  if (fedexBrandEmailSwitchery.is(":checked")) {
    sandBoxEmailFlag = true;
    console.log('sandBoxEmailFlag ' + sandBoxEmailFlag);
  } else {
    sandBoxEmailFlag = false;
    console.log('sandBoxEmailFlag ' + sandBoxEmailFlag);
  }
});

//Sandbox Config step 4 override default shipping swich 
overrideShippingSwitchery.on('change', function (e) {
  if (overrideShippingSwitchery.is(":checked")) {
    SandboxOverrideShippingFlag = true;
    console.log('SandboxOverrideShippingFlag ' + SandboxOverrideShippingFlag);
  } else {
    SandboxOverrideShippingFlag = false;
    console.log('SandboxOverrideShippingFlag ' + SandboxOverrideShippingFlag);
  }
});

//Sandbox Config step 4 override ship to address swich 
overrideAddressSwitchery.on('change', function (e) {
  if (overrideAddressSwitchery.is(":checked")) {
    sandboxShippingAddressFlag = true;
    console.log('sandboxShippingAddressFlag ' + sandboxShippingAddressFlag);
  } else {
    sandboxShippingAddressFlag = false;
    console.log('sandboxShippingAddressFlag ' + sandboxShippingAddressFlag);
  }
});

//step 4 email ,default shipping and address ajax sandbox
function saveEmailShippingAddress({ urlEsa }) {
  {
    $.ajax({
      data: {
        "fedexBrandedEmail": sandBoxEmailFlag,
        "defaultShippingOverride": SandboxOverrideShippingFlag,  
        "shippingAddressOverride": sandboxShippingAddressFlag,
        "defaultProduct": useDefaultItemFlagforSB        
      },
      url: urlEsa,
      dataType: 'JSON',
      type: 'POST',
      success: function (data) {
        console.log('res1 '+ data.status );    
        console.log('prod email,orverride shipping,address ajax ' + JSON.stringify(data));  
      }
    });
  }
}

function addReason({ url }) {
  {
    $.ajax({
      data: {
        "cdmValue": $(".return-reason-short-value").val(),
        "cdmMeaning": $(".retunr-reason-display-value").val(),
      },
      url: url,
      dataType: 'JSON',
      type: 'POST',
      success: function (response) {
        debugger;
        responseData = response.data;
        console.log('prod in reason ajax ' + JSON.stringify(response.data));  

        console.log("cdmValue --> "+ responseData.cdmValue);
        console.log("cdmMeaning --> "+ responseData.cdmMeaning);
        if(responseData.cdmValue !== null && responseData.cdmMeaning !== null){
        document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue +'    '+ responseData.cdmMeaning + '</li>';  

       }   

       $(".return-reason-short-value").val('');
       $(".retunr-reason-display-value").val('');

      }      

      });       

  }
}


  //for copying text
  function copyToClipboard() {
    CopyToClipbrd("https://fulfillment.fedex.com", true, "URL copied");
  }

  function CopyToClipbrd(value, showNotification, notificationText) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();

    if (typeof showNotification === 'undefined') {
        showNotification = true;
    }
    if (typeof notificationText === 'undefined') {
        notificationText = "Copied to clipboard";
    }

    var notificationTag = $("div.copy-url-notification");
    if (showNotification && notificationTag.length == 0) {
        notificationTag = $("<div/>", { "class": "copy-url-notification", text: notificationText });
        $("body").append(notificationTag);

        notificationTag.fadeIn("slow", function () {
            setTimeout(function () {
                notificationTag.fadeOut("slow", function () {
                    notificationTag.remove();
                });
            }, 1000);
        });
    }
}

  init();

  // END: REAL CODE
};



// WEBPACK FOOTER //
// ./src/pages/rmaMerchantSelfOnboarding/rmaMerchantAccountConfigurationSandbox.js